// API Configuration
export const API_BASE_URL = import.meta.env.VITE_APP_API_URL || ''; 